import { render, staticRenderFns } from "./page-footer.vue?vue&type=template&id=a915da68&"
import script from "./page-footer.js?vue&type=script&lang=js&"
export * from "./page-footer.js?vue&type=script&lang=js&"
import style0 from "./page-footer.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports